import { render, staticRenderFns } from "./ApiTester.vue?vue&type=template&id=4f0056c2&scoped=true&"
import script from "./ApiTester.vue?vue&type=script&lang=js&"
export * from "./ApiTester.vue?vue&type=script&lang=js&"
import style0 from "./ApiTester.vue?vue&type=style&index=0&id=4f0056c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0056c2",
  null
  
)

export default component.exports